import React, { Component } from 'react';
import PropTypes from 'prop-types';

class BreadcrumbElement extends Component {
  handleOnClick = () => {
    const { data: { onClick } } = this.props;

    if (onClick) {
      onClick();
    }
  }

  render() {
    const { data: { text, onClick }, isFirst } = this.props;

    return (
      <React.Fragment>
        {!isFirst ? (<i className='fas fa-chevron-right' />) : null}
        <div onClick={this.handleOnClick} className={onClick ? 'clickable' : ''}>{text}</div>
      </React.Fragment>
    );
  }
}

BreadcrumbElement.propTypes = {
  data: PropTypes.object.isRequired,
  isFirst: PropTypes.bool,
};

BreadcrumbElement.defaultProps = {
  isFirst: false,
};

export default BreadcrumbElement;



// WEBPACK FOOTER //
// ./src/components/Layout/components/BreadcrumbElement.jsx